import React from "react"

function About() {
    return(
        <div>
            This is the about page.
        </div>
    );
}

export default About;